/** @module app.test */

import { ITest, ITestResult } from 'app/test/types';
import { TestContext } from 'app/test/context';
import { sleep } from 'app/shared/lib/utilities';

export class TestRunner {

    public delayMilliseconds: number = 0;

    private readonly tests: ITest[] = [];

    constructor(...tests: ITest[]) {
        this.tests.push(...tests);
    }

    public async run(context: TestContext): Promise<void> {
        for(const test of this.tests) {
            let passed: boolean = false;
            let error: Error | undefined;
            const startTime = new Date();
            try {
                if(this.delayMilliseconds) {
                    await sleep(this.delayMilliseconds);
                }

                await test.run();

                context.passed++;
                passed = true;
            }
            catch(caughtError) {
                context.failed++;
                //console.error(error, test);

                passed = false;
                if(caughtError instanceof Error) {
                    error = caughtError;
                }
                else {
                    error = new Error(`Wrapped Error: ${caughtError}`);
                }
            }
            const endTime = new Date();

            context.total++;

            const result: ITestResult = {
                fixture: test.fixture,
                test: test.name,
                args: test.args,
                passed,
                error,
                executionTime: endTime.getTime() - startTime.getTime(),
                output: [...context.output]
            }

            // reset output
            context.resetOutput();

            context.results.push(result);
        }
    }

}
